export default __webpack_public_path__ + "74cd34c35f6b026744a8b4e5fe8ba037.png";